import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import { loginAs, logoutAs, goToZendesk } from '../../../stores/auth/actionCreators';
import {
    canSeeUpdatePage, isLoggedInAs
} from '../../../stores/auth/selectors';
import { activePage } from '../../../stores/navigation/selectors';
import { RootState } from '../../../stores/store';

interface Props extends LocalizeContextProps, RouteComponentProps {
    canSeeUpdatePage: boolean;
    isLoggedInAs: boolean;

    loginAs: (id: string) => void;
    logoutAs: (refreshTable?: boolean) => void;
    goToZendesk: () => void;
    active: string;    
}

class BottomNav extends React.Component<Props> {
    public render() {
        const t = this.props.translate;
        return (
            <React.Fragment>
                {/* {this.props.canSeeUpdatePage ? (
                    <li className="fixed-bottom bottom-2">
                        <Link to={{ pathname: '/update', state: { from: this.props.location } }}>
                            <FontAwesomeIcon icon={['fal', 'arrow-up']} />{t('sidebar.button.update')}</Link>
                    </li>
                ) : null} */}

                <li className="fixed-bottom bottom-2">
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            this.props.goToZendesk();
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'question-circle']} /> {t('sidebar.button.help')}
                    </a>
                </li>
                <li className="fixed-bottom bottom-1">
                    <Link to={{ pathname: '/select-app', state: { from: this.props.location } }}>
                        <FontAwesomeIcon icon={['fal', 'th-large']} />{t('sidebar.button.goToApplications')}</Link>
                </li>
                {!this.props.isLoggedInAs ? (
                    <li className="fixed-bottom">
                        <Link to={{ pathname: '/logout', state: { from: this.props.location } }}>
                            <FontAwesomeIcon icon={['fal', 'sign-out']} />{t('sidebar.button.logout')}
                        </Link>
                    </li>
                ) : (
                        <li className="fixed-bottom">
                            <a
                                onClick={() =>
                                    this.props.logoutAs(true)}
                            >
                                <FontAwesomeIcon icon={['fal', 'sign-out']} /> {t('sidebar.button.logoutAs')}
                            </a>
                        </li>
                    )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    active: activePage(state),
    canSeeUpdatePage: canSeeUpdatePage(state),
    isLoggedInAs: isLoggedInAs(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToZendesk: () => dispatch(goToZendesk()),
    loginAs: (id: string) => dispatch(loginAs(id)),
    logoutAs: (refreshTable?: boolean) => dispatch(logoutAs(false, refreshTable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(BottomNav)));